export const downloadFile = (blob: Blob|null, name: string, finishedMessage?: string): string => {
  if (!blob) {
    return 'Não há arquivos para baixar';
  }
  const newBlob = new Blob([blob], {type: 'application/octet-stream'});
  // Corrigir uso de msSaveOrOpenBlob para evitar erro de tipagem
  const nav = window.navigator as any;
  if (nav && typeof nav.msSaveOrOpenBlob === 'function') {
    nav.msSaveOrOpenBlob(newBlob);
    return finishedMessage || 'Download concluído';
  }

  const data = window.URL.createObjectURL(newBlob);
  const link = document.createElement('a');
  link.href = data;
  link.download = name;
  link.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true, view: window}));
  setTimeout(() => {
    window.URL.revokeObjectURL(data);
    link.remove();
  }, 100);
  return finishedMessage || 'Download concluído';
};

export const convertBase64ToBlobData = (base64Data: string, contentType: string= 'image/png', sliceSize= 512): Blob => {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  return new Blob(byteArrays, {type: contentType});
};
